export default __webpack_public_path__ + "static/media/foreignPlateIcon.6c6614eb.svg";